// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1518":"4c28caa534500df1","5428":"752843bfd7dc7013","7581":"25c83d4cbbf63e73","9812":"c3a1635ac50b9277"}[chunkId] + ".js";
};